/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolEmptyRequest,
  MarqCommonProtocolEmptyResponse,
  MarqCommonProtocolFileResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetSnapshotRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetSnapshotResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetStartDateRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetStartDateResponse,
  PerfCommercePerformanceCleanlinessProtocolsGetStatusRequest,
  PerfCommercePerformanceCleanlinessProtocolsGetStatusResponse,
  PerfCommercePerformanceLandscapingProtocolsGetCountryAndRegionResponse,
  PerfCommercePerformanceLandscapingProtocolsGetPlatformDetailRequest,
  PerfCommercePerformanceLandscapingProtocolsGetPlatformDetailResponse,
  PerfCommercePerformanceLandscapingProtocolsGetReportListRequest,
  PerfCommercePerformanceLandscapingProtocolsGetReportListResponse,
  PerfCommercePerformanceLandscapingProtocolsGetReportRequest,
  PerfCommercePerformanceLandscapingProtocolsGetReportResponse,
  PerfCommercePerformanceLandscapingProtocolsGetSlideLinkRequest,
  PerfCommercePerformanceLandscapingProtocolsGetSlideLinkResponse,
  PerfCommercePerformanceLandscapingProtocolsGetWorldMapDetailRequest,
  PerfCommercePerformanceLandscapingProtocolsGetWorldMapDetailResponse,
  PerfCommercePerformanceLandscapingProtocolsGetWorldMapRequest,
  PerfCommercePerformanceLandscapingProtocolsGetWorldMapResponse,
  PerfCommercePerformanceProtocolsGetClientCountryListResponse,
  PerfCommercePerformanceProtocolsGetCohortAnalysisCsvRequest,
  PerfCommercePerformanceProtocolsGetCohortAnalysisFilterRequest,
  PerfCommercePerformanceProtocolsGetCohortAnalysisFilterResponse,
  PerfCommercePerformanceProtocolsGetCohortAnalysisRequest,
  PerfCommercePerformanceProtocolsGetCohortAnalysisResponse,
  PerfCommercePerformanceProtocolsGetComplianceRateRequest,
  PerfCommercePerformanceProtocolsGetComplianceRateResponse,
  PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsRequest,
  PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponse,
  PerfCommercePerformanceProtocolsGetCountriesRequest,
  PerfCommercePerformanceProtocolsGetCountriesResponse,
  PerfCommercePerformanceProtocolsGetDomainsRequest,
  PerfCommercePerformanceProtocolsGetDomainsResponse,
  PerfCommercePerformanceProtocolsGetEnforcedValueRequest,
  PerfCommercePerformanceProtocolsGetEnforcedValueResponse,
  PerfCommercePerformanceProtocolsGetExpertServicesRequest,
  PerfCommercePerformanceProtocolsGetExpertServicesResponse,
  PerfCommercePerformanceProtocolsGetImpactedSellerRequest,
  PerfCommercePerformanceProtocolsGetImpactedSellerResponse,
  PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeRequest,
  PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeResponse,
  PerfCommercePerformanceProtocolsGetTopInfringingSellersRequest,
  PerfCommercePerformanceProtocolsGetTopInfringingSellersResponse,
  PerfCommercePerformanceProtocolsGetWebsiteCountsRequest,
  PerfCommercePerformanceProtocolsGetWebsiteCountsResponse,
  PerfCommercePerformanceReportProtocolsGetListRequest,
  PerfCommercePerformanceReportProtocolsGetListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Performance<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Performance
   * @name CountryListList
   * @request GET:/performance/country-list
   */
  countryListList = (params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetClientCountryListResponse, any>({
      path: `/performance/country-list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CountriesCreate
   * @request POST:/performance/countries
   */
  countriesCreate = (data: PerfCommercePerformanceProtocolsGetCountriesRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetCountriesResponse, any>({
      path: `/performance/countries`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DomainsCreate
   * @request POST:/performance/domains
   */
  domainsCreate = (data: PerfCommercePerformanceProtocolsGetDomainsRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetDomainsResponse, any>({
      path: `/performance/domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name WebsiteCountsCreate
   * @request POST:/performance/website-counts
   */
  websiteCountsCreate = (data: PerfCommercePerformanceProtocolsGetWebsiteCountsRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetWebsiteCountsResponse, any>({
      path: `/performance/website-counts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name EnforcedValueCreate
   * @request POST:/performance/enforced-value
   */
  enforcedValueCreate = (data: PerfCommercePerformanceProtocolsGetEnforcedValueRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetEnforcedValueResponse, any>({
      path: `/performance/enforced-value`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ImpactedSellerCreate
   * @request POST:/performance/impacted-seller
   */
  impactedSellerCreate = (data: PerfCommercePerformanceProtocolsGetImpactedSellerRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetImpactedSellerResponse, any>({
      path: `/performance/impacted-seller`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ComplianceRateCreate
   * @request POST:/performance/compliance-rate
   */
  complianceRateCreate = (data: PerfCommercePerformanceProtocolsGetComplianceRateRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetComplianceRateResponse, any>({
      path: `/performance/compliance-rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ExpertServicesCreate
   * @request POST:/performance/expert-services
   */
  expertServicesCreate = (data: PerfCommercePerformanceProtocolsGetExpertServicesRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetExpertServicesResponse, any>({
      path: `/performance/expert-services`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisCsvCreate
   * @request POST:/performance/cohort-analysis-csv
   */
  cohortAnalysisCsvCreate = (
    data: PerfCommercePerformanceProtocolsGetCohortAnalysisCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/cohort-analysis-csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisFilterCreate
   * @request POST:/performance/cohort-analysis/filter
   */
  cohortAnalysisFilterCreate = (
    data: PerfCommercePerformanceProtocolsGetCohortAnalysisFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceProtocolsGetCohortAnalysisFilterResponse, any>({
      path: `/performance/cohort-analysis/filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name TopInfringingSellersCreate
   * @request POST:/performance/top-infringing-sellers
   */
  topInfringingSellersCreate = (
    data: PerfCommercePerformanceProtocolsGetTopInfringingSellersRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceProtocolsGetTopInfringingSellersResponse, any>({
      path: `/performance/top-infringing-sellers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ListingsTimeCreate
   * @request POST:/performance/listings-time
   */
  listingsTimeCreate = (
    data: PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeResponse, any>({
      path: `/performance/listings-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ComplianceRateTopCreate
   * @request POST:/performance/compliance-rate-top
   */
  complianceRateTopCreate = (
    data: PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponse, any>({
      path: `/performance/compliance-rate-top`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisCreate
   * @request POST:/performance/cohort-analysis
   */
  cohortAnalysisCreate = (data: PerfCommercePerformanceProtocolsGetCohortAnalysisRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceProtocolsGetCohortAnalysisResponse, any>({
      path: `/performance/cohort-analysis`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ReportListCreate
   * @request POST:/performance/report/list
   */
  reportListCreate = (data: PerfCommercePerformanceReportProtocolsGetListRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceReportProtocolsGetListResponse, any>({
      path: `/performance/report/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessStatusCreate
   * @request POST:/performance/cleanliness/status
   */
  cleanlinessStatusCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetStatusRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetStatusResponse, any>({
      path: `/performance/cleanliness/status`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessStartDateCreate
   * @request POST:/performance/cleanliness/start-date
   */
  cleanlinessStartDateCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetStartDateRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetStartDateResponse, any>({
      path: `/performance/cleanliness/start-date`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessAiInsightsCreate
   * @request POST:/performance/cleanliness/ai-insights
   */
  cleanlinessAiInsightsCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsResponse, any>({
      path: `/performance/cleanliness/ai-insights`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessSnapshotCreate
   * @request POST:/performance/cleanliness/snapshot
   */
  cleanlinessSnapshotCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetSnapshotResponse, any>({
      path: `/performance/cleanliness/snapshot`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessSnapshotByDomainCreate
   * @request POST:/performance/cleanliness/snapshot-by-domain
   */
  cleanlinessSnapshotByDomainCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponse, any>({
      path: `/performance/cleanliness/snapshot-by-domain`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessSnapshotByKeywordCreate
   * @request POST:/performance/cleanliness/snapshot-by-keyword
   */
  cleanlinessSnapshotByKeywordCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponse, any>({
      path: `/performance/cleanliness/snapshot-by-keyword`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessRateCreate
   * @request POST:/performance/cleanliness/rate
   */
  cleanlinessRateCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendResponse, any>({
      path: `/performance/cleanliness/rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessRateDetailCreate
   * @request POST:/performance/cleanliness/rate-detail
   */
  cleanlinessRateDetailCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponse, any>({
      path: `/performance/cleanliness/rate-detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessRateDomainsCreate
   * @request POST:/performance/cleanliness/rate-domains
   */
  cleanlinessRateDomainsCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterResponse, any>({
      path: `/performance/cleanliness/rate-domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessExportSnapshotByDomainCreate
   * @request POST:/performance/cleanliness/export-snapshot-by-domain
   */
  cleanlinessExportSnapshotByDomainCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/cleanliness/export-snapshot-by-domain`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessExportSnapshotByKeywordCreate
   * @request POST:/performance/cleanliness/export-snapshot-by-keyword
   */
  cleanlinessExportSnapshotByKeywordCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/cleanliness/export-snapshot-by-keyword`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CleanlinessExportRateDetailCreate
   * @request POST:/performance/cleanliness/export-rate-detail
   */
  cleanlinessExportRateDetailCreate = (
    data: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/cleanliness/export-rate-detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingReportListCreate
   * @request POST:/performance/landscaping/report/list
   */
  landscapingReportListCreate = (
    data: PerfCommercePerformanceLandscapingProtocolsGetReportListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetReportListResponse, any>({
      path: `/performance/landscaping/report/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingReportCreate
   * @request POST:/performance/landscaping/report
   */
  landscapingReportCreate = (
    data: PerfCommercePerformanceLandscapingProtocolsGetReportRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetReportResponse, any>({
      path: `/performance/landscaping/report`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingWorldMapCreate
   * @request POST:/performance/landscaping/world-map
   */
  landscapingWorldMapCreate = (
    data: PerfCommercePerformanceLandscapingProtocolsGetWorldMapRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetWorldMapResponse, any>({
      path: `/performance/landscaping/world-map`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingWorldMapDetailsCreate
   * @request POST:/performance/landscaping/world-map/details
   */
  landscapingWorldMapDetailsCreate = (
    data: PerfCommercePerformanceLandscapingProtocolsGetWorldMapDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetWorldMapDetailResponse, any>({
      path: `/performance/landscaping/world-map/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingPlatformDetailCreate
   * @request POST:/performance/landscaping/platform-detail
   */
  landscapingPlatformDetailCreate = (
    data: PerfCommercePerformanceLandscapingProtocolsGetPlatformDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetPlatformDetailResponse, any>({
      path: `/performance/landscaping/platform-detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingRegionWithCountryList
   * @request GET:/performance/landscaping/region-with-country
   */
  landscapingRegionWithCountryList = (params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetCountryAndRegionResponse, any>({
      path: `/performance/landscaping/region-with-country`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingContactSalesCreate
   * @request POST:/performance/landscaping/contact-sales
   */
  landscapingContactSalesCreate = (data: MarqCommonProtocolEmptyRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/performance/landscaping/contact-sales`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name LandscapingExportCreate
   * @request POST:/performance/landscaping/export
   */
  landscapingExportCreate = (
    data: PerfCommercePerformanceLandscapingProtocolsGetSlideLinkRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceLandscapingProtocolsGetSlideLinkResponse, any>({
      path: `/performance/landscaping/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
